"use strict";

define('rs/abstract.app',['require','exports','module','vertebrae','./language','e3-common','e3-modal','e3-form','rs/header/header.controller','rs/authenticate/authenticate.controller','rs/abstract.app.view','rs/helper','rs/models/session','evisions/pipe','rs/error/error.manager','rs/errors','rs/services/abstract.service','jquery','handlebars','cookie','respond','bootstrap','rs/global.events','evisions/uuid'],function (require, exports, module) {
  var Vertebrae = require('vertebrae');
  var Language = require('./language');
  var E3 = require('e3-common');
  var E3Modal = require('e3-modal');
  var E3Form = require('e3-form');
  var HeaderController = require('rs/header/header.controller');
  var AuthenticateController = require('rs/authenticate/authenticate.controller');
  var AbstractAppView = require('rs/abstract.app.view');
  var helper = require('rs/helper');
  var Session = require('rs/models/session');
  var Pipe = require('evisions/pipe');
  var ErrorManager = require('rs/error/error.manager');
  var RSError = require('rs/errors');
  var AbstractService = require('rs/services/abstract.service');
  var $ = require('jquery');
  var Handlebars = require('handlebars');
  var _cookie = require('cookie');
  var _respond = require('respond');
  var Bootstrap = require('bootstrap');
  var _GlobalEvents = require('rs/global.events');
  var uuid = require('evisions/uuid');
  window.Vertebrae = Vertebrae;
  window.E3Common = E3;
  window.E3Modal = E3Modal;
  window.E3Form = E3Form;
  var App = Vertebrae.App.extend({
    properties: ['authenticateController', 'headerController', 'loadingStack', 'view', 'user'],
    applyTracker: false,
    languagePacks: [],
    content: '#content',
    errorModal: null,
    applicationMenuLinks: [{
      name: 'IRB/Compliance',
      link: '../irb/'
    }, {
      name: 'Administration',
      link: '../admin/',
      requiredPermissions: ['ADMIN']
    }],
    trackerDomains: ['*.cayuse.com', '*.cayuse424.com'],
    events: {
      'start': null
    },
    observes: {
      'sessionExpire': 'sessionDidExpire',
      'window-resize': 'resize'
    },
    controllers: {
      'authenticateController #login': AuthenticateController
    },
    templates: {},
    template: 'init',
    defaultRoute: '',
    helpURL: '',
    initialize: function initialize() {
      Vertebrae.View.setupTemplates(this.templates);
      Language.setup(this.languagePacks);
      _.each(this.templates, function (fn, name) {
        Handlebars.registerPartial(name, fn);
      });
      this.setLoadingStack([]);
      window.app = this;
      AbstractService.app = this;
      $(window).on('beforeunload', _.bind(this.onBeforeUnload, this));
      this.processPipes();
      this._super.apply(this, arguments);
    },
    store: {
      get: function get(key) {
        var result = null;
        try {
          var cookieVal = $.cookie(key);
          if (cookieVal) {
            result = JSON.parse(cookieVal).data;
          }
        } catch (e) {
          $.removeCookie(key);
        }
        return result;
      },
      set: function set(key, value) {
        $.cookie(key, JSON.stringify({
          data: value
        }), {
          expires: 365
        });
      }
    },
    getPerson: function getPerson() {
      return this.getUser().getPerson();
    },
    checkPermission: function checkPermission(permission) {
      return this.getPerson().hasPermission(permission || '');
    },
    checkRole: function checkRole(role) {
      return this.getPerson().hasRole(role || '');
    },
    processPipes: function processPipes() {
      var i = 0,
        list = window._pipeList,
        pipe = null,
        len = list ? list.length : 0;
      for (i = 0; i < len; ++i) {
        pipe = list[i];
        pipe.trigger('load', this);
      }
      window._pipeList = null;
    },
    getApplicationLinks: function getApplicationLinks() {
      var that = this,
        _applicationLinks = [];
      _.each(this.applicationMenuLinks, function (menuLink) {
        if (!menuLink.requiredPermissions || that.getPerson().hasPermissions(menuLink.requiredPermissions)) {
          if (menuLink.name != that.AppName) {
            _applicationLinks.push(menuLink);
          }
        }
      });
      return _applicationLinks;
    },
    getNavigationLinks: function getNavigationLinks() {
      if (this._navLinkCache) {
        return this._navLinkCache;
      }
      var person = this.getPerson();
      var user = this.getUser();
      var _filterList = function filterList(list) {
        list = _.filter(list, function (item) {
          var authorized = true;
          if (item.children) {
            item.children = _filterList(item.children);
          }
          if (!item.route && !item.link && (!item.children || !item.children.length)) {
            return false;
          }
          if (item.requiredFeature) {
            authorized &= person.supportsFeature(item.requiredFeature);
          }
          if (item.requiredUsers) {
            authorized &= item.requiredUsers.indexOf(user.userName) > -1;
          }
          if (item.requiredPermissions) {
            authorized &= person.hasPermissions(item.requiredPermissions);
          }
          return !!authorized;
        });
        return list;
      };
      this._navLinkCache = _filterList(this.navigationLinks);
      return this._navLinkCache;
    },
    hasNotifications: function hasNotifications() {
      return true;
    },
    generateHelpLink: function generateHelpLink(id) {
      return this.helpURL + (id ? '#CSHID=' + id : '');
    },
    setupAnalytics: function setupAnalytics(user) {
      var domain = String(document.domain);
      this.applyTracker = _.some(this.trackerDomains, function (match) {
        match = '^' + match.replace(/\./g, '\\.').replace(/\*/g, '.*') + '$';
        return domain.match(new RegExp(match));
      });
    },
    start: function start() {
      this._super().bind(this).tap(function () {
        this.listenToOnce(this.getAuthenticateController(), 'authenticated', this.userIsAuthenticated);
      });
      return this;
    },
    canSetupController: function canSetupController(controller) {
      var person = this.getPerson();
      return controller.isAccessAllowed(person);
    },
    canLeaveContentController: function canLeaveContentController() {
      if (!this.getContentController()) {
        return true;
      }
      return this.getContentController().canLeaveContentController();
    },
    unloadContentController: function unloadContentController() {
      if (!this.getContentController()) {
        return Promise.resolve();
      }
      return this.getContentController().unloadContentController();
    },
    saveHash: function saveHash() {
      var hash = this.getHash();
      if (hash) {
        $.cookie('RS.SessionRoute', hash);
      }
    },
    navigate: function navigate(url, options) {
      this.trackPageView(url);
      options = options || {};
      if (options.pipe) {
        var win = window.open(window.location.pathname + '#' + url);
        return Pipe.create(window, win);
      }
      _.defer(_.bind(this.saveHash, this));
      return this._super.apply(this, arguments);
    },
    initializeContentController: function initializeContentController() {
      var controller = this._super.apply(this, arguments);
      this.updateTitle();
      return controller;
    },
    updateTitle: function updateTitle() {
      var appTitle = this.AppTitle ? this.AppTitle + ' - ' : '',
        controllerTitle = this.getControllerDocumentTitle() || 'Evisions - Research Suite';
      document.title = appTitle + controllerTitle;
      return this;
    },
    getControllerDocumentTitle: function getControllerDocumentTitle() {
      var controller = this.getContentController();
      if (controller && controller.getDocumentTitle) {
        return controller.getDocumentTitle() || '';
      }
      ;
    },
    setupAppView: function setupAppView(el, delegate) {
      return AbstractAppView.setup(el, delegate);
    },
    getTemplateProperties: function getTemplateProperties() {
      return this.getUser();
    },
    userIsAuthenticated: function userIsAuthenticated(user) {
      var authenticateController = this.getAuthenticateController(),
        authenticatedPerson = user.getPerson();
      if (authenticateController) {
        authenticateController.destroy();
      }
      this.setUser(user);
      if (this.requiredFeature && !authenticatedPerson.supportsFeature(this.requiredFeature)) {
        return this.showUserIsNotAuthorized();
      }
      if (!_.isEmpty(this.requiredPermissions) && !authenticatedPerson.hasPermissions(this.requiredPermissions)) {
        return this.showUserIsNotAuthorized();
      }
      this.startApp();
    },
    showUserIsNotAuthorized: function showUserIsNotAuthorized() {
      return E3Modal.BtnMsgModal.show({
        title: 'Warning',
        message: 'You have insufficient permissions to access this page.'
      });
    },
    startApp: function startApp() {
      var routeHash = $.cookie('RS.SessionRoute');
      $.removeCookie('RS.SessionRoute');
      this.setView(this.setupAppView(this.$el.empty(), this));
      this.getView().render();
      this.setupAnalytics(this.getUser());
      this.routing(routeHash);
    },
    showLoading: function showLoading() {
      return app.request('dimmer', {
        legacy: true
      });
    },
    onBeforeUnload: function onBeforeUnload() {
      if (this.getContentController() && this.getContentController().hasVolatileData()) {
        return this.getContentController().getVolatileDataMessage();
      }
    },
    requestMenuItems: function requestMenuItems() {
      return Promise.reject().ignore();
    },
    requestRoute: function requestRoute(route) {
      if (route && route.slice(0, 2) == '//') {
        window.location.pathname = '.' + route.slice(1);
      } else {
        this.navigate(route, {
          trigger: true
        });
      }
    },
    loadLogoutRedirect: function loadLogoutRedirect() {
      var logoutUrl, destination;
      if (Session.isOneLogin()) {
        Session.clearHeartbeat();
        Session.removeOneLoginToken();
        logoutUrl = window.location.origin + '/logout';
        window.location = encodeURI(logoutUrl);
      } else {
        destination = this.getUser().getRedirectPath();
        this.saveHash();
        if (!destination || !window.production) {
          window.location.reload();
        } else {
          window.location = destination;
        }
      }
    },
    requestLogout: function requestLogout() {
      var user = this.getUser();
      return Promise.resolve(this.canLeaveContentController()).bind(this).then(this.unloadContentController).then(function () {
        return user.logout();
      }).then(function () {
        this.blackoutContent();
        this.loadLogoutRedirect();
      });
    },
    blackoutContent: function blackoutContent() {
      this.destroyContentController();
      if (this.getView()) {
        this.getView().blackoutContent();
      }
    },
    sessionDidExpire: function sessionDidExpire(reason) {
      var title = null,
        message = null,
        that = this,
        section = null,
        modal = null;
      switch (reason) {
        case 'error':
          title = "Error";
          message = "Your session has expired because there was an error communicating with the server.";
          break;
        case 'timeout':
          title = "Attention";
          message = "Your session has timed out due to inactivity.";
          break;
        case 'log-out':
          break;
        default:
          title = "Attention";
          message = "Your session has expired.";
          break;
      }
      this.blackoutContent();
      Session.clearHeartbeat();
      if (reason != "log-out") {
        section = E3Modal.BtnMsgModal.create({
          title: title,
          message: message,
          buttons: 'Close'
        });
        this.errorModal = E3Modal.Controller.create(section);
        this.errorModal.getView().$el.addClass(' error-modal');
        return this.errorModal.show().bind(this).lastly(this.loadLogoutRedirect);
      } else {
        if (Session.isOneLogin()) {
          Session.clearHeartbeat();
          Session.removeOneLoginToken();
        }
        ErrorManager.get().modalDidHide();
        destination = window.location.origin + '/logout';
        window.location = destination;
      }
    },
    trackEvent: function trackEvent(event, properties) {},
    trackPageView: function trackPageView(hash, properties, options) {
      if (this.applyTracker) {
        ga('send', 'pageview', '/#' + hash);
      }
    },
    resize: function resize() {}
  });
  Vertebrae.App.Errors.CannotRoute = Vertebrae.Utils.createError('CannotRoute', 'You have insufficient permissions to access this page.');
  module.exports = App;
});

